module.exports = __webpack_public_path__ + "static/media/wrapper-button-start.36976c30.png";